module.exports = __webpack_public_path__ + "img/198.93f76cf1.jpg";